import { FormFields, FormHeader, FormSection } from '../form';
import { useValidation } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { claimFields } from '../../../../config';
import { Input } from '../../../../components';

import type { Dispatch, FC, SetStateAction } from 'react';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

interface IInternalIdentificationsProps {
  setSaveAndQuitChanges?: Dispatch<SetStateAction<Array<string>>>;
}

export const InternalIdentifications: FC<IInternalIdentificationsProps> = ({ setSaveAndQuitChanges }) => {
  const formContext = useFormContext();
  const { fieldRequirements } = useValidation({});
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  const isNodeUnknown: boolean = formContext.watch('isNodeUnknown') ?? false;

  const onIsNodeUnknownChange = (checked: boolean) => {
    setSaveAndQuitChanges?.((prev) => [...prev, 'ClaimNode']);
    formContext.setValue(claimFields.claimNode, checked ? localization.translate('dropdownOptions.unknown') : '');
    formContext.setValue('isNodeUnknown', checked);
    formContext.clearErrors('isNodeUnknown');
    formContext.clearErrors(claimFields.claimNode);
  };

  return (
    <FormSection>
      <FormHeader>{localization.translate('internalIdentifications.header')}</FormHeader>

      <FormFields>
        {/* HUB */}
        <Input
          inputOptions={{
            isRequired: fieldRequirements.ClaimHub,
            label: localization.translate('internalIdentifications.hubLabel'),
            name: claimFields.claimHub,
            onChange: (_) => setSaveAndQuitChanges?.((prev) => [...prev, 'ClaimHub']),
          }}
          tooltip={localization.translate('internalIdentifications.hubTooltip')}
        />

        {/* NODE */}
        <Input
          checkboxOptions={{
            'aria-label': localization.translate('internalIdentifications.nodeCheckboxLabel'),
            isSelected: isNodeUnknown,
            onChange: onIsNodeUnknownChange,
          }}
          inputOptions={{
            isDisabled: isNodeUnknown ?? false,
            isRequired: fieldRequirements.ClaimNode,
            label: localization.translate('internalIdentifications.nodeLabel'),
            name: claimFields.claimNode,
            onChange: (_) => setSaveAndQuitChanges?.((prev) => [...prev, 'ClaimNode']),
          }}
          tooltip={localization.translate('internalIdentifications.nodeTooltip')}
        />

        {/* OUTAGE ID */}
        <div className={'flex w-full'}>
          <Input
            inputOptions={{
              isRequired: fieldRequirements.RemedyId,
              label: localization.translate('internalIdentifications.outageIdLabel'),
              name: claimFields.remedyId,
              onChange: (_) => setSaveAndQuitChanges?.((prev) => [...prev, 'RemedyID']),
            }}
            tooltip={localization.translate('internalIdentifications.outageIdTooltip')}
          />
        </div>
      </FormFields>
    </FormSection>
  );
};